import React from 'react';
import { useApp } from '../components/AppContext';
import { MainLayout } from '../components/MainLayout';

export function CheckOut() {
  const { navigateDirectly } = useApp();
  return (
    <MainLayout showBack={true} onBack={() => navigateDirectly('dashboard')}>
      <div className="text-center py-8">
        <h1 className="text-2xl font-bold text-[var(--ucm-text-dark)] mb-4">Auschecken</h1>
        <p className="text-[var(--ucm-text-medium)] mb-6">Schicht abschließen und Feedback geben.</p>
        <div className="bg-[var(--ucm-light-blue)] rounded-2xl p-6">
          <p className="text-[var(--ucm-dark-blue)]">Check-out-Funktion kommt bald...</p>
        </div>
      </div>
    </MainLayout>
  );
}